import { Box } from '@mui/material';
import MessageInput from './MessageInput';
import MessageList from './MessageList';

export default function ChatConversation({ messages, isTyping, onSend,  onEdit, onDelete, variant = 'full', compact = false }) {
  const isEmbedded = variant === 'embedded';
  const isEmpty = messages.length === 0;
  return (
    <Box
      sx={{
        minHeight: isEmbedded ? 'auto' : '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
      }}
    >
      {/* Messages */}
      {!isEmpty && (
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            pb: compact ? '64px' : '96px'
          }}
        >
          <Box sx={{ maxWidth: compact ? '100%' : 995, mx: 'auto', px: compact ? 0 : 3 }}>
            <MessageList messages={messages} isTyping={isTyping} onEdit={onEdit} onDelete={onDelete} compact={compact} />
          </Box>
        </Box>
      )}

      {/* Sticky input */}
      <Box
        sx={{
          position: isEmpty ? 'relative' : 'sticky',
          bottom: 0,
          background: 'background.default'
        }}
      >
        <Box sx={{ maxWidth: compact ? '100%' : isEmbedded ? 880 : 990, mx: 'auto', px: compact ? 0 : isEmbedded ? 0 : 3, py: compact ? 1 : 2 }}>
          <MessageInput onSend={onSend} compact={compact} />
        </Box>
      </Box>
    </Box>
  );
}
